<template>
  <b-container id="exp" class="pb-2" fluid>
    <h3>
      <b-row no-gutters align-v="center" cols="3">
        <b-col cols="1">
          <font-awesome-icon icon="bolt" size="xs" />
        </b-col>
        <b-col class="pt-1">
          <span>
            Experience
          </span>
        </b-col>
      </b-row>
    </h3>
    <b-container class="pt-4 mt-1 ml-4 pl-2" v-for="(w, v, i) in work" :key="i">
      <span class="pb-2">
        <b>{{ w[0] }}</b>
        <span class="ml-3 text-muted">{{ w[2] }}</span>
        <span class="ml-3 font-italic text-muted">{{ w[1] }}</span>
      </span>
      <b-row class="mt-1 ml-2 pl-1" v-for="i in w.slice(3)" :key="i">
        {{i}}
      </b-row>
    </b-container>
  </b-container>
</template>
<script>
import experience from '@/assets/experience.json'
export default {
  components: {},
  data () {
    return {
      work: experience.work
    }
  },
  computed: {},
  methods: {}
}
</script>

<style>
#about {
}

.head {
  padding-left: 10px;
}
.icons {
  display: flex;
}
</style>
